import axios, { AxiosInstance } from 'axios';
import { Endpoints } from '../endpoints';

export interface GetEobsRequest {}

export interface Eob {
  docStorageId: string;
  dateCreated: string;
  isDeletable: number;
}

/**
 * Get Explanation of Benifit downloads available to the app user.
 * Not yet implemented - C2-4432
 * This is currently just a forced OK response.
 * @param params
 * @param instance - Axios instance that will be used to query the API.
 * @returns
 */
export const getEobs = async (instance: AxiosInstance = axios) =>
  instance.get<Eob[]>(Endpoints.EOB.LIST_EOB);
